import React, { Component } from "react";
import HeaderNavBar from "../HeaderNavBar/HeaderNavBar";
import ScrolltoTop from "../ScrollTop/ScrollTop";
import Footer from "../Footerpage/Footer";
import "../ForInvestors/ForInvestors.css";
import CMSTranslationFile from "../ForInvestors/ForInvestors_Translation_Corp.json";
import Image from "../../Assests/for-investors.webp";
import TranslationFile from "../Translation/Translation_corp.json";
import { Helmet } from "react-helmet";
let userSelectedLanguage;

class ForInvestors extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    userSelectedLanguage = localStorage.getItem("selectedLanguage");

    window.scrollTo(0, 0);
  }
  callback = () => {
    this.setState({
      reRender: true
    });
  };

  render() {
    if (userSelectedLanguage == null) {
      userSelectedLanguage = "sw";
    }
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            {userSelectedLanguage == "sw"
              ? TranslationFile.FaviconAppText[userSelectedLanguage]
              : TranslationFile.FaviconAppText.en}
          </title>
        </Helmet>

        <HeaderNavBar callBack={this.callback} />
        <div className="ID_ForInvestors">
          <br></br>
          <br></br>
          <div
            style={{
              // fontSize: "30px",
              textAlign: "center"
            }}
          >
            <strong>
              {" "}
              {CMSTranslationFile.ForInvestors_Title[userSelectedLanguage]}
            </strong>
            {/* For Investors */}
          </div>
          <br></br>
          <section
            style={{
              // fontSize: "20px",
              textAlign: "left"
            }}
          >
            {CMSTranslationFile.ForInvestors_Text1[userSelectedLanguage]}
          </section>
          <br></br>
          <br></br>
          <center>
            {" "}
            <img src={Image} className="forInvestorsImage" />
          </center>
        </div>
        <ScrolltoTop />
        <Footer />
      </div>
    );
  }
}
export default ForInvestors;
